<script>
import { benefits } from "@/views/home/utils/benefits.js";

export default {
  name: "home-benefits",
  data() {
    return {
      benefits: benefits,
    };
  },
  methods: {
    viewMore() {
      window.open(
        "https://www.grupodpsp.com.br/quem-somos/#diversidade",
        "_blank"
      );
    },
  },
};
</script>

<template>
  <div class="some-benefits">
    <div class="container">
      <h2>Alguns de nossos benefícios</h2>
      <p>Os benefícios podem variar de acordo com o cargo e a unidade.</p>
      <ul class="d-flex flex-wrap justify-content-center align-items-center">
        <li v-for="(benefit, index) in benefits" :key="index">
          <div>
            <img
              :src="require(`@/assets/images/dpsp/icons/a${index + 1}.png`)"
              alt=""
            />
          </div>
          <p>
            {{ benefit }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/benefits.scss"></style>